import { useRef, useEffect } from "react";
import { usePurchase } from "../../../../../global/paywall/usePurchase";
import { SubscriptionPlan } from "../../../../../global/paywall/paywallInterfaces";


interface PaywallCheckoutPaymentDetailsProps {
    nextStep: () => void
    selectedPlan: SubscriptionPlan
}

const PaywallCheckoutMobilePaymentDetails = (props: PaywallCheckoutPaymentDetailsProps) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const {selectedPlan} = props;
    const { purchaseStatus, paymentUrl, error, resetPurchase } = usePurchase(selectedPlan.productUniqueId);
    
        useEffect(() => {
        if (purchaseStatus === "completed") {
            props.nextStep()
        }
    }, [purchaseStatus])

    return (
        <div className="PaywallCheckoutPaymentDetails">
            <div className="title"> פרטי תשלום</div>
            <div className="creditcard-details-container">
                <iframe ref={iframeRef as any} src={paymentUrl} />
            </div>
        </div>
    );
};

export default PaywallCheckoutMobilePaymentDetails;